module.exports = {
    width: 230,
    height: 150,
  }